// To parse this data:
//
//   import { Convert, ListFolderFiles } from "./file";
//
//   const listFolderFiles = Convert.toListFolderFiles(json);

export interface ListFolderFiles {
  items?:       Item[];
  totalPages?:  number;
  totalItems?:  number;
  currentPage?: number;
}

export interface SelectedFolder {
  folder_id:    string;
  folder_name:  string;
}

export interface Item {
  type?:                   Type;
  file_id?:                string | null;
  user_id?:                string | null;
  file_name?:              null | string;
  created_at?:             string;
  updated_at?:             string;
  directory_id?:           string;
  file_path?:              null | string;
  file_size?:              number | null;
  file_category?:          null | string;
  mime_type?:              null | string;
  original_filename?:      null | string;
  description?:            null | string;
  s3_url?:                 null | string;
  s3_key?:                 null | string;
  s3_bucket?:              null | string;
  s3_redirect_url?:        null | string;
  checksum?:               null | string;
  year?:                   number | null;
  month?:                  number | null;
  file_type?:              null | string;
  download_count?:         number | null;
  view_count?:             number | null;
  backup_s3_url?:          null;
  backup_s3_key?:          null;
  backup_s3_bucket?:       null;
  backup_s3_redirect_url?: null;
  thumbnail_s3_key?:       null | string;          
  thumbnail_s3_url?:       null | string;      
  thumbnail_s3_redirect_url?: null | string;      
  backup_thumbnail_s3_key?: null | string;         
  backup_thumbnail_s3_url?: null | string;          
  backup_thumbnail_s3_redirect_url?: null | string; 
  is_trashed?:             number;
  is_trashed_soft?:        number;
  date_trashed_soft?:      null;
  date_trashed?:           null;
  folder_id?:              string | null;
  name?:                   null | string;
  parent_folder_id?:       null;
  path?:                   null | string;
  is_favorite?:            number;
  owner?: string; // A string listing usernames who have access
  share_with_usernames?: string | "-"; // A string listing usernames who have access
 
}

export enum Type {
  File = "file",
  Folder = "folder",
}

// Converts JSON strings to/from your types
export class Convert {
  public static toListFolderFiles(json: string): ListFolderFiles {
      return JSON.parse(json);
  }

  public static listFolderFilesToJson(value: ListFolderFiles): string {
      return JSON.stringify(value);
  }
}
